/*
 * House of Daisy — <hod-copy-code>: shows a "Copy code" button next to a
 * discount code and copies it to the clipboard. Without JavaScript, or where
 * the clipboard is unavailable, the button stays hidden and the code is
 * simply shown as text.
 */
if (!customElements.get('hod-copy-code')) {
  customElements.define(
    'hod-copy-code',
    class HodCopyCode extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button || !navigator.clipboard) return;
        this.label = this.button.textContent;
        this.button.hidden = false;
        this.button.addEventListener('click', () => this.copy());
      }

      async copy() {
        try {
          await navigator.clipboard.writeText(this.dataset.code);
          this.button.textContent = this.dataset.copied;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => (this.button.textContent = this.label), 2000);
        } catch (error) {
          // Clipboard refused (permissions, insecure context): the code is still on screen.
        }
      }
    }
  );
}
